import { endpoints } from "../Api/configs";
import apiClient from "./apiClient";

export const searchEventAPI = async (query: string) => {
  const url = `${endpoints.events.searchEvent}?query=${encodeURIComponent(
    query
  )}`;
  return apiClient(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const allRankingAPI = async () => {
  return apiClient(endpoints.events.allRanking, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};
export const rankingAPI = async (query: any, accessToken: string) => {
  const url = `${endpoints.events.ranking}?gameTitle=${encodeURIComponent(
    query
  )}&accessToken=${accessToken}`;
  return apiClient(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const buyTicket = async (bodyParams: any) => {
  return apiClient(endpoints.events.buyTicket, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      body: bodyParams,
    }),
  });
};

export const fetchPopularEvents = async (
  query: string,
  limit: number,
  lastEvaluatedKey = null
) => {
  let url = `${endpoints.events.eventsPopular}?query=${encodeURIComponent(
    query
  )}&limit=${limit}`;
  if (lastEvaluatedKey) {
    url += `&lastEvaluatedKey=${encodeURIComponent(lastEvaluatedKey)}`;
  }
  return apiClient(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const fetchRecommendedEvents = async (
  username: string,
  limit: number,
  lastEvaluatedKey = null
) => {
  const bodyParams = {
    userID: username,
  };
  let url = `${endpoints.events.eventsRecommended}?limit=${limit}`;
  if (lastEvaluatedKey) {
    url += `&lastEvaluatedKey=${encodeURIComponent(lastEvaluatedKey)}`;
  }

  return apiClient(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      body: bodyParams,
    }),
  });
};

export const fetchUpcomingEvents = async (
  query: string,
  limit: number,
  lastEvaluatedKey = null
) => {
  let url = `${endpoints.events.eventsUpcoming}?query=${encodeURIComponent(
    query
  )}&limit=${limit}`;
  if (lastEvaluatedKey) {
    url += `&lastEvaluatedKey=${encodeURIComponent(lastEvaluatedKey)}`;
  }
  return apiClient(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const fetchEventDetails = async (
  eventID: string,
  accessToken: string,
  type?: string
) => {
  const url = `${
    endpoints.events.eventsDetails
  }${eventID}&accessToken=${accessToken}${type ? `&type=${type}` : ""}`;

  return apiClient(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchUserEvents = async (
  username: string,
  limit: number,
  lastEvaluatedKey = null
) => {
  const bodyParams = { username };
  let url = `${endpoints.events.userEvents}?limit=${limit}`;
  if (lastEvaluatedKey) {
    url += `&lastEvaluatedKey=${encodeURIComponent(lastEvaluatedKey)}`;
  }
  return apiClient(url, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const searchUsers = async (bodyParams: any) => {
  return apiClient(endpoints.events.searchUsers, {
    method: "POST",
    body: JSON.stringify({ body: bodyParams }),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const getUsersSuggestion = async (accessToken: any) => {
  return apiClient(endpoints.events.suggestions, {
    method: "POST",
    body: JSON.stringify({ accessToken: accessToken }),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const createEvent = async (bodyParams: any) => {
  return apiClient(endpoints.events.createEvent, {
    method: "POST",
    body: JSON.stringify(bodyParams),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const createWatchingEvent = async (bodyParams: any) => {
  return apiClient(endpoints.events.watchingEvent, {
    method: "POST",
    body: JSON.stringify(bodyParams),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const signUpEvent = async (bodyParams: any) => {
  return apiClient(endpoints.events.signUpEvent, {
    method: "POST",
    body: JSON.stringify({ body: bodyParams }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const ticketEvent = async (bodyParams: any) => {
  return apiClient(endpoints.events.ticketEvent, {
    method: "POST",
    body: JSON.stringify({ body: bodyParams }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const updateEvent = async (bodyParams: any) => {
  return apiClient(endpoints.events.updateEvent, {
    method: "PATCH",
    body: JSON.stringify({ body: bodyParams }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const sendChallenge = async (bodyParams: any, accessToken: string) => {
  return apiClient(endpoints.events.sendChallenge, {
    method: "POST",
    body: bodyParams,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: accessToken,
    },
  });
};

export const ChallengeUserNotificationHandler = async (
  eventId: string,
  challengerId: string,
  accessToken: string
) => {
  return apiClient(endpoints.events.ChallengeUserNotificationHandler, {
    method: "POST",
    body: JSON.stringify({
      accessToken: accessToken,
      eventId,
      challengerId,
    }),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: accessToken,
    },
  });
};

export const getChallengeList = async (accessToken: string) => {
  return apiClient(endpoints.events.challengeAlertList, {
    method: "POST",
    body: JSON.stringify({
      accessToken: accessToken,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getAllNotificationList = async (accessToken: string) => {
  return apiClient(endpoints.events.getAllNotifications, {
    method: "POST",
    body: JSON.stringify({
      accessToken: accessToken,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const deleteNotification = async (
  accessToken: string,
  eventId: string
) => {
  return apiClient(endpoints.events.deleteNotification, {
    method: "POST",
    body: JSON.stringify({
      accessToken: accessToken,
      eventId: eventId,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const getNotificationFromEvent = async (
  accessToken: string,
  eventId: string
) => {
  return apiClient(endpoints.events.getNotificationFromEvent, {
    method: "POST",
    body: JSON.stringify({
      accessToken: accessToken,
      eventId: eventId,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getChallengeDetails = async (id: string) => {
  const url = `${endpoints.events.challengeDetails}${id}`;
  return apiClient(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const respondToChallenge = async (bodyParams: any) => {
  return apiClient(endpoints.events.challengeRespond, {
    method: "POST",
    body: JSON.stringify(bodyParams),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchIveChallengeList = async (accessToken: string) => {
  return apiClient(endpoints.events.IvechallengeAlertList, {
    method: "POST",
    body: JSON.stringify({ accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateStreamPlatform = async (
  accessToken: string,
  eventID: string,
  platform: string,
  enable: boolean,
  willEnableMultiStream: boolean = false
) => {
  return apiClient(endpoints.events.platform, {
    method: "POST",
    body: JSON.stringify({
      accessToken,
      eventID,
      platform,
      enable,
      willEnableMultiStream,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateEventAutoLive = async (
  accessToken: string,
  eventID: string,
  enable: boolean
) => {
  return apiClient(endpoints.events.autoLive, {
    method: "POST",
    body: JSON.stringify({
      accessToken,
      eventID,
      enable,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const submitEventResult = async (bodyParams: any) => {
  return apiClient(endpoints.events.submitResult, {
    method: "POST",
    body: JSON.stringify(bodyParams),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchPastEvents = async (
  accessToken,
  limit: number,
  lastEvaluatedKey = null
) => {
  let url = `${endpoints.pastEvent.fetchPastEvent}?limit=${limit}`;
  if (lastEvaluatedKey) {
    url += `&lastEvaluatedKey=${encodeURIComponent(lastEvaluatedKey)}`;
  }
  return apiClient(url, {
    method: "POST",
    body: JSON.stringify({ accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const FetchUserPastEvents = async (
  accessToken,
  limit: number,
  lastEvaluatedKey = null
) => {
  let url = `${endpoints.pastEvent.fetchUserPastEvent}?limit=${limit}`;
  if (lastEvaluatedKey) {
    url += `&lastEvaluatedKey=${encodeURIComponent(lastEvaluatedKey)}`;
  }
  return apiClient(url, {
    method: "POST",
    body: JSON.stringify({ accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const fetchSpecificPastEvent = async (eventId, accessToken) => {
  return apiClient(endpoints.pastEvent.fetchPastEventById, {
    method: "POST",
    body: JSON.stringify({ eventId, accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const checkInEvent = async (accessToken: string, eventId: string) => {
  return apiClient(endpoints.events.checkIn, {
    method: "POST",
    body: JSON.stringify({
      accessToken: accessToken,
      eventID: eventId,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const confirmAttendance = async (
  accessToken: string,
  eventId: string,
  notificationId: string
) => {
  return apiClient(endpoints.events.confirmAttentDance, {
    method: "POST",
    body: JSON.stringify({
      accessToken: accessToken,
      eventID: eventId,
      notificationId,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const FetchTwitchUrlKey = async (
  accessToken: string,
  eventId: string
) => {
  return apiClient(endpoints.events.twitchUrlKey, {
    method: "POST",
    body: JSON.stringify({
      AccessToken: accessToken,
      eventId,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const FetchYouTubeUrlKey = async (
  accessToken: string,
  eventId: string
) => {
  return apiClient(endpoints.events.youTubeUrlKey, {
    method: "POST",
    body: JSON.stringify({
      AccessToken: accessToken,
      eventId,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const logPublicVoteForEvent = async (
  accessToken: string,
  eventID: string,
  vote: string
) => {
  return apiClient(endpoints.events.logPublicVote, {
    method: "POST",
    body: JSON.stringify({
      accessToken: accessToken,
      eventID: eventID,
      vote: vote,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const enablePublicVote = async (
  accessToken: string,
  eventID: string,
  enablePublicVoting: boolean
) => {
  return apiClient(endpoints.events.publicVoteEnable, {
    method: "POST",
    body: JSON.stringify({
      accessToken: accessToken,
      eventId: eventID,
      enablePublicVoting: enablePublicVoting,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchUserUpcomingEvents = async (
  username,
  limit: number,
  lastEvaluatedKey = null
) => {
  let url = `${endpoints.events.getUserUpcomingEvents}?limit=${limit}`;
  if (lastEvaluatedKey) {
    url += `&lastEvaluatedKey=${encodeURIComponent(lastEvaluatedKey)}`;
  }
  return apiClient(url, {
    method: "POST",
    body: JSON.stringify({ username }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchUserWatchingEvents = async (
  username,
  limit: number,
  lastEvaluatedKey = null
) => {
  let url = `${endpoints.events.getUserWatchingEvents}?limit=${limit}`;
  if (lastEvaluatedKey) {
    url += `&lastEvaluatedKey=${encodeURIComponent(lastEvaluatedKey)}`;
  }
  return apiClient(url, {
    method: "POST",
    body: JSON.stringify({ body: { username } }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const cancelEvent = async (
  accessToken: string,
  eventID: string,
  reason: string,
  message: string
) => {
  return apiClient(endpoints.events.cancelEvent, {
    method: "POST",
    body: JSON.stringify({
      accessToken: accessToken,
      eventId: eventID,
      reason,
      message,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getEventForNotLoginUser = async (eventId: string) => {
  const url = `${endpoints.events.getEventForNotLoginUser}?eventId=${eventId}`;
  return apiClient(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};
